// extracted by mini-css-extract-plugin
export var standaloneTable = "_f1-0";
export var standaloneTableWithBodyFill = "_f1-1";
export var withExtraHeader = "_f1-2";